import { Button } from "@babybjorn/ui";
import GridItem from "../../components/general/GridItem";
import Text from "../../components/Text";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import Link from "../../components/general/Link";
import Icon from "../../components/general/Icon";

const TextModule = ({
	textAlignLeft,
	label,
	headline,
	content,
	buttons,
}: Queries.TextModuleFragment) => {
	const firstButton = buttons?.[0];
	const secondButton = buttons?.[1];

	const firstButtonProps = {
		href: getUrlFromStoryblokLink(firstButton?.link),
		label: firstButton?.label ?? "",
		icon: firstButton?.icon,
	};
	const secondButtonProps = {
		href: getUrlFromStoryblokLink(secondButton?.link),
		label: secondButton?.label ?? "",
		icon: secondButton?.icon,
	};

	return (
		<GridItem data-id="text-module">
			<Text
				textAlignLeft={textAlignLeft}
				label={label}
				headline={headline}
				content={content}
			>
				{firstButton && (
					<Button
						variant="secondary"
						asChild
						size={
							firstButtonProps.icon && !firstButtonProps.label
								? "icon"
								: "default"
						}
					>
						<Link href={firstButtonProps.href}>
							{firstButtonProps.icon && (
								<Icon icon={firstButtonProps.icon} color="inherit" />
							)}
							{firstButtonProps.label && <span>{firstButtonProps.label}</span>}
							<span className="sr-only">Link</span>
						</Link>
					</Button>
				)}
				{firstButton && secondButton && (
					<Button
						variant="ghost"
						asChild
						size={
							secondButtonProps.icon && !secondButtonProps.label
								? "icon"
								: "default"
						}
					>
						<Link href={secondButtonProps.href}>
							{secondButtonProps.icon && (
								<Icon icon="arrow-right" color="inherit" />
							)}
							{secondButtonProps.label && (
								<span>{secondButtonProps.label}</span>
							)}
							<span className="sr-only">Link</span>
						</Link>
					</Button>
				)}
			</Text>
		</GridItem>
	);
};
export default TextModule;
